import z from 'zod';

export const Schema = z.object({
  variant: z.literal('express-theme'),
});
